const versionToastMsg = {
  /**
   *  [상품 전체 리스트] 상품 전체 리스트 요청하기
   */
  GET_VERSION_LIST_REQUEST_SUCCESS: '버전 전체 리스트 요청하기 성공',
  GET_VERSION_LIST_REQUEST_ERROR: '버전 전체 리스트 요청하기 실패',

  /**
   *  [버전 등록] 버전 등록 요청하기
   */
  INSERT_VERSION_REQUEST_SUCCESS: '버전 등록 요청하기 성공',
  INSERT_VERSION_REQUEST_ERROR: '버전 등록 요청하기 실패',

  /**
   *  [버전 편집] 버전 편집 요청하기
   */
  EDIT_VERSION_REQUEST_SUCCESS: '버전 편집 요청하기 성공',
  EDIT_VERSION_REQUEST_ERROR: '버전 편집 요청하기 실패',

  /**
   *  [버전 삭제] 버전 삭제 요청하기
   */
  DELETE_VERSION_REQUEST_SUCCESS: '버전 삭제 요청하기 성공',
  DELETE_VERSION_REQUEST_ERROR: '버전 삭제 요청하기 실패',

  /**
   *  [버전 상세] 버전 상세 요청하기
   */
  GET_VERSION_INFO_REQUEST_SUCCESS: '버전 상세 요청하기 성공',
  GET_VERSION_INFO_REQUEST_ERROR: '버전 상세 요청하기 실패',
};

export default versionToastMsg;
